import { render, staticRenderFns } from "./IntegrationView.vue?vue&type=template&id=e8380084&scoped=true"
import script from "./IntegrationView.vue?vue&type=script&lang=js"
export * from "./IntegrationView.vue?vue&type=script&lang=js"
import style0 from "./IntegrationView.vue?vue&type=style&index=0&id=e8380084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8380084",
  null
  
)

export default component.exports